import { PersonalCardListPage } from 'app-next/[workspace]/cards/personal/page';
import { NextPageWithLayout } from 'pages/_app';

// Later this can go to a Card Template list page, right now it just goes to the preset edit page in view mode
const page: NextPageWithLayout = PersonalCardListPage;

export default page;
